// removed by extract-text-webpack-plugin
module.exports = {"postFailMessage":"_2R99Lk0VPrqZFw6eCkU_dQ","loadingIndicator":"MXZyHL7JC6DaNN2PEF0nj","passwordValidateMessage":"_2XtDhu7QD_HyUjYJuN9ixq","usernameValidateMessage":"_3VqHkXVdCb-K0bYYZUb5RH","welcomeMessage":"_2_FYcJfRZCRbMwAp8ozltS","introPar":"_1Ye8EWGpQFFNCetgDk9j19","demoInfo":"_3OOfZLfEBJ8oJzzxId2tz_","signupContain":"_3VaYkxdpWPu-zuPdh6PU75","signupLabel":"_31GfPX3OzZHmkRXvm5bnQk","signupInput":"kcyXTT2b4Xns3NOjavYZp","formContain":"_2t64UxUk0pXjhe8NtDDXYd","submitSignupButton":"_2bvh5fwutj8Wbp-9SGX1E-","linkToTop":"_1wekmBCur7BgxBxRKVFSON","newLinkToTop":"_3xH_uJgDX03q84E29c5aQ5"};


//////////////////
// WEBPACK FOOTER
// ./src/componentStyles/Signup.css
// module id = 403
// module chunks = 0